import styled from 'styled-components';

import {ms} from '../../../../styles';
import {LottieView} from '../../../../uikit/LottieView';
import {Text} from '../../../../uikit/Text';
import {TextArea} from '../../../../uikit/TextArea';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  flex-direction: column;
  gap: ${ms(platform.isWeb ? 20 : 15)};
`;

export const Animation = styled(LottieView)`
  height: ${ms(150)};
  width: 100%;
  align-self: center;

  @media (max-height: 844px) {
    height: ${ms(100)};
  }
`;

export const Title = styled(Text).attrs({variant: 'h2', weight: 'semibold'})`
  text-align: center;

  @media (max-height: 844px) {
    font-size: ${ms(18)};
    line-height: ${ms(26)};
  }
`;

export const TextAreaWrap = styled(View)`
  flex-direction: column;
  gap: ${ms(8)};
`;

export const CommentInput = styled(TextArea)`
  min-height: ${ms(100)};
`;

export const ExplanationText = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${ms(16)};
  line-height: ${ms(24)};
  letter-spacing: ${ms(-0.47)};
  text-align: center;

  @media (max-height: 844px) {
    font-size: ${ms(14)};
    line-height: ${ms(20)};
  }
`;
